





















import { tableComposition } from '@/compositions/table'
import { defineComponent } from '@vue/composition-api'
import { remittanceBalanceSelfController } from '~/api/Remittances/remittances.api'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'

export default defineComponent({
  components: {
    FlatCard,
    FlatTable,
  },
  setup: () => {
    return {
      ...tableComposition(remittanceBalanceSelfController),
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('agency.agency'),
          value: 'agency_name',
        },
        {
          text: this.$t('delivery_currency'),
          value: 'delivery_currency',
        },
        {
          text: this.$t('balance'),
          value: 'balance',
        },
      ],
    }
  },
})
